export default __webpack_public_path__ + "static/media/coins.98aba3fd.svg";